const RouteNames = {
    home: 'home',
    signIn: 'sign-in',
    aclAccounts: 'acl-accounts',
};

export default RouteNames;